import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import React from 'react';
import { connect } from "react-redux";
import General from './general.js'
import { withNamespaces } from 'react-i18next';
import { isMobile } from 'react-device-detect';

export class TabContainer extends React.Component{
    render(){  
        const { t } = this.props

        return(
            <div className="dashboardTabsAdmin">
                <Tabs>
                    <TabList className={isMobile ? 'react-tabs__tab-list__mobile' : 'react-tabs__tab-list'}>
                        <Tab style={{width: isMobile ? "auto" : null}}>{t('General')}</Tab>
                        {this.props.user.roles.indexOf("ADMIN") > -1 &&  this.props.user.roles.indexOf("POWERADMIN") === -1?   
                            <Tab>{t('Templates')}</Tab>   
                        : null }
                    </TabList>
                    {!isMobile ? 
                        <hr className="p-0 m-0" />
                    : null }
                    <TabPanel>
                        <General />
                    </TabPanel>
                </Tabs>
            </div>
        )
    };
};

const mapStateToProps = state => {
    return {    
        user: state.user  
    };
};
  
const mapDispatchToProps = dispatch => {
    return {
        mapState: (type, data) => dispatch({ type: type, data: data}),
        API: (type, data) => dispatch({ type: type, data: data})
    };
};
  
  
  
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withNamespaces()(TabContainer));
